/* CART CLEANUP - Christmas Spirit. When the product leaves the cart, its add-ons and free gifts leave with it.

   Owner, 2026-09-17: "Once you delete the main item, you know, the upsells are not supposed to stay. They should get
   deleted... once you delete the main product, the rest of the upsells and the free gifts still stay there. I would
   never want this to happen. Yeah, always remember this."

   Measured that day on the live store: removing Christmas Lights from the drawer or the /cart page left Priority
   Shipping, Shipping Protection, 90 Day Warranty, Mystery Gift Box and the Free Shipping gift in the cart, after a
   reload too. The theme does have a "clear the cart when only upsells are left" rule, but it only knows the upsells
   configured inside the cart drawer, not the add-ons ticked on the product page.

   The rule here: a cart line is an ADD-ON when its product type is "Upsell" - every add-on and the gift on this store
   carries that type, and the lights carry none. Whenever a cart holds add-ons and nothing else, it is emptied with the
   theme's own clearCart, which also redraws the drawer or the cart page as empty.

   When it looks: after every cart change the theme announces (its cart-update event and cartQuantityUpdated), and
   once when a page opens, so a cart left like that earlier is still cleaned. Loaded after main.js from theme.liquid.
   Test: builds/xmas-led-lights/store-theme/cart_cleanup_check.py (every removal path, plus two removals that must
   NOT empty the cart, plus a blocked-script run that must show the old defect). */
(function () {
  'use strict';

  // the add-on product type is a theme setting (Theme settings > Store extras); 'upsell' when it is not set
  var ADDON_TYPE = String((window.KC_CART_CLEANUP && window.KC_CART_CLEANUP.addonType) || 'upsell')
    .trim().toLowerCase();
  var SOURCE = 'kc-cart-cleanup';
  var timer = null;
  var running = false;
  var again = false;

  function isAddOn(item) {
    return String(item.product_type || '').trim().toLowerCase() === ADDON_TYPE;
  }

  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + path;
  }

  function onlyAddOnsLeft(cart) {
    var items = (cart && cart.items) || [];
    if (!items.length) return false;
    for (var i = 0; i < items.length; i++) {
      if (!isAddOn(items[i])) return false;
    }
    return true;
  }

  function announce() {
    // let every other cart view (the drawer on the cart page, the header bubble) redraw itself
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE });
    }
  }

  function emptyCart() {
    var list = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    if (list && typeof list.clearCart === 'function') {
      // the theme's clearCart does not hand back its request (measured 2026-09-17: reading the cart straight after
      // it still found the add-ons), so wait for the server to show the cart emptied before doing anything else
      list.clearCart();
      return settled(8, 300).then(function (done) { return done ? announce() : plainClear(); });
    }
    return plainClear();
  }

  // resolves true once the cart no longer holds add-ons alone (emptied, or a product is back), false if it still
  // does after tries x ms
  function settled(tries, ms) {
    return new Promise(function (resolve) {
      (function poll(left) {
        setTimeout(function () {
          fetch(cartUrl('/cart.js'), { credentials: 'same-origin', cache: 'no-store' })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              if (!onlyAddOnsLeft(cart)) resolve(true);
              else if (left <= 1) resolve(false);
              else poll(left - 1);
            })
            .catch(function () { if (left <= 1) resolve(false); else poll(left - 1); });
        }, ms);
      })(tries);
    });
  }

  function plainClear() {
    return fetch(cartUrl('/cart/clear.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    }).then(function () {
      announce();
      // no theme cart list to redraw it: the cart page must not keep showing lines that are gone
      if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
    });
  }

  function check() {
    if (running) { again = true; return; }
    running = true;
    fetch(cartUrl('/cart.js'), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return onlyAddOnsLeft(cart) ? emptyCart() : null; })
      .catch(function () {})
      .then(function () {
        running = false;
        if (again) { again = false; schedule(); }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(check, 250);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === SOURCE) return;
      schedule();
    });
  }
  document.addEventListener('cartQuantityUpdated', schedule);
  window.addEventListener('pageshow', schedule);
  schedule();
})();
